<template>
    <div class="wb-toggle" :class="classes" @click="handleClick">
        <input type="checkbox" :checked="active" />
        <div class="wb-toggle__container">
            <div class="wb-toggle__circle" />
        </div>
        <span class="wb-toggle__label">
            <slot name="label" />
        </span>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps<{
        name?: string
        disabled?: boolean
        loading?: boolean
    }>()

    defineEmits<{
        'update:modelValue': [value: boolean]
        change: [value: boolean]
    }>()

    const model = defineModel({ default: false })

    const active = computed(() => model.value)

    const classes = computed(() => ({
        _active: active.value,
        _disabled: props.disabled,
        _loading: props.loading
    }))

    function handleClick() {
        if (!props.disabled) {
            model.value = !model.value

            // emit('update:modelValue', model.value)
            // emit('change', model.value)
        }
    }
</script>

<style scoped lang="scss">
    .wb-toggle {
        $toggle: &;

        display: flex;
        align-items: center;
        width: max-content;
        max-width: 100%;
        cursor: pointer;

        &._active {
            #{$toggle}__container {
                background-color: var(--blue-600);
            }

            #{$toggle}__circle {
                transform: translateX(calc((var(--circle-size) + (var(--circle-size) / 2))));
            }
        }

        &__container {
            flex-shrink: 0;
            width: 48px;
            height: 24px;
            padding: 4px;
            border-radius: 30px;
            background-color: var(--blue-200);
            cursor: pointer;
        }

        &__circle {
            --circle-size: 16px;

            width: var(--circle-size);
            height: var(--circle-size);
            border-radius: 50%;
            background-color: var(--white);
            transform: translateX(0);
            transition: transform 0.2s ease;
        }

        &__label {
            margin-left: 10px;
        }
    }
</style>
